import { render, staticRenderFns } from "./SuperAdminCompanyCourseSettings.vue?vue&type=template&id=0ed08271"
import script from "./SuperAdminCompanyCourseSettings.vue?vue&type=script&lang=js"
export * from "./SuperAdminCompanyCourseSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports